export default [{
  path: '/pacote-servicos',
  component: {
    name: 'pacotesServicoBase',
    template: '<router-view />',
    meta: {
      resource: 'pacoteservico',
      action: 'read',
      requiredAuth: true,
      breadcrumb: [
        { text: '', to: { path: '/' } },
      ],
    },
  },
  children: [{
    path: 'visualizar',
    name: 'pacote-servicos',
    component: () => import('@/app-modulo/comercial/pacote-servico/PacoteServicoView.vue'),
    meta: {
      resource: 'pacoteservico',
      action: 'read',
      requiredAuth: true,
      navActiveLink: 'pacote-servicos',
      pageTitle: 'Cadastro de pacote',
      breadcrumb: [
        {
          text: 'Pacote de Serviços',
          to: { name: 'pacoteservicos' },
          active: true,
        },
      ],
    },
  },
  {
    path: 'novo',
    name: 'novo-pacote-servicos',
    component: () => import('@/app-modulo/comercial/pacote-servico/shared/components/cadastro/PacoteServico.vue'),
    meta: {
      resource: 'pacoteservico',
      action: 'create',
      requiredAuth: true,
      navActiveLink: 'pacote-servicos',
      pageTitle: 'Cadastro de pacote',
      breadcrumb: [
        {
          text: 'Pacote de Serviços',
          to: { name: 'pacote-servicos' },
        },
        {
          text: 'Novo',
          to: { name: 'novo-pacote-servicos' },
          active: true,
        }],
    },
  },
  {
    path: 'editar/:id',
    name: 'editar-pacote-servicos',
    component: () => import('@/app-modulo/comercial/pacote-servico/shared/components/cadastro/PacoteServico.vue'),
    meta: {
      resource: 'pacoteservico',
      action: 'update',
      requiredAuth: true,
      navActiveLink: 'pacote-servicos',
      pageTitle: 'Cadastro de pacote',
      breadcrumb: [
        {
          text: 'Pacote de Serviços',
          to: { name: 'pacote-servicos' },
        },
        {
          text: 'Editar',
          to: { name: 'editar-pacote-servicos' },
          active: true,
        }],
    },
  },
  {
    path: 'copia/:copia/copiaId/:id',
    name: 'copiar-pacote-servicos',
    component: () => import('@/app-modulo/comercial/pacote-servico/shared/components/cadastro/PacoteServico.vue'),
    meta: {
      resource: 'pacoteservico',
      action: 'create',
      navActiveLink: 'pacote-servicos',
      pageTitle: 'Cadastro de pacote',
      breadcrumb: [
        {
          text: 'Pacote de Serviços',
          to: { name: 'pacote-servicos' },
        },
        {
          text: 'Copiar',
          to: { name: 'copiar-pacote-servicos' },
          active: true,
        },
      ],
    },
  }],
},
]
